<script>
import { Cell, Stepper } from 'vant'

export default {
    //--------------------------------------------------
	// component name
	//--------------------------------------------------
    name: 'integer-stepper-field',

    //--------------------------------------------------
	// component components
	//--------------------------------------------------
    components: {
        'van-cell': Cell,
        'van-stepper': Stepper,
    },

    //--------------------------------------------------
    // component props
    //--------------------------------------------------
    props: {
        label: String,
        value: Number,
        defaultValue: Number,
        min: Number,
        max: Number,
        disabled: Boolean
	},

    //--------------------------------------------------
    // component emits
    //--------------------------------------------------
	emits: ['change-data'],

    //--------------------------------------------------
    // component data
    //--------------------------------------------------
    data() {
        return {
            count: 0,
        }
    },

    //--------------------------------------------------
    // computed setter and getter
    //--------------------------------------------------
    computed: {
        defaultValueField() {
            return this.defaultValue ? this.defaultValue : 0
        },
        minField() {
            return this.min ? this.min : 0
        },
        maxField() {
            return this.max ? this.max : 99
        },
    },

    //--------------------------------------------------
    // component watch
    //--------------------------------------------------
    watch: {
        /**
         * Watch the parent attribute to update the child property.
         */
        value(value) {
            console.log('watch value', value, typeof(value))
            this.count = !isNaN(value) ? value : 0
        }
    },

    //--------------------------------------------------
    // component methods
    //--------------------------------------------------
    methods: {
        onStepperChange() {
            console.log('onStepperChange', this.count)
            this.$emit('change-data', this.count)
        }
    },
}
</script>

<template>
    <!-- component -->
    <div class="integer-stepper-field van-cell no-padding">
        <van-cell 
            :class="{ disabled: disabled }" 
            :title="label"
        >
            <template #default>
                <van-stepper 
                    v-model="count"
                    :default-value="defaultValueField"
                    :min="minField"
                    :max="maxField"
                    :integer="true"
                    :disable-input="true"
                    :disabled="disabled"
                    @change="onStepperChange"
                />
            </template>
        </van-cell>
    </div>
</template>